import { ref } from 'vue'

// Bridge between the vanilla email-section code (application.js) and the Vue
// TipTap editor (EmailEditor.vue), mirroring quickset.js.
//
// - emailSeed: vanilla sets this to the composed body HTML from /email_draft;
//   the editor watches it and loads the content.
// - emailHtml: the editor writes its current HTML here on every change; vanilla
//   reads it when creating the Outlook draft.
// - emailReady: true once the editor holds generated content (gates the button).
export const emailSeed  = ref(null)
export const emailHtml  = ref('')
export const emailReady = ref(false)

// Seed the editor with freshly composed body HTML.
export function seedEmail(html) {
  emailSeed.value = { html, at: Date.now() }
  // Gate the Outlook button on content synchronously. The EmailEditor watcher
  // also (re)sets this, but it runs on a later tick — too late for the
  // synchronous updateEmailSection() call right after seedEmail() in
  // generateEmail(), which would otherwise leave the button stuck disabled
  // until some later, unrelated updateEmailSection() call.
  emailReady.value = !!html
}

// Clear the editor (on reset).
export function clearEmail() {
  emailSeed.value = { html: '', at: Date.now() }
  emailHtml.value = ''
  emailReady.value = false
}
